import { observer } from 'mobx-react-lite'
import { Icon, Switch, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IPhoneCheckrProps = {
  validateNumbers: boolean
  onToggle: (value: boolean) => void
  onSeeDetails: () => void
}

export const PhoneCheckr = observer(
  ({ validateNumbers, onToggle, onSeeDetails }: IPhoneCheckrProps) => {
    return (
      <div className={styles.infoContainer}>
        <div className={styles.iconContainer}>
          <Icon icon={'usersCheck'} color={'var(--content-brand-primary)'} />
        </div>
        <div className={styles.infoContainerData}>
          <Typography ariaLabel={'sectionTitle'} variant='body-md-semibold'>
            PhoneCheckr
          </Typography>
          <Typography
            ariaLabel={'description'}
            variant='body-md-regular'
            color='var(--content-primary-tertiary)'
          >
            Improve deliverability by validating contact&apos;s numbers. <br />
            $0.01 / lookup.
          </Typography>
        </div>
        <div className={styles.switchContainer}>
          <div className={styles.switchContainerButtons}>
            <Switch ariaLabel='switch' size='small' value={validateNumbers} onChange={onToggle} />
          </div>
          <Typography
            ariaLabel='see_details'
            variant='body-md-medium'
            className={styles.seeDetailsLink}
            onClick={onSeeDetails}
          >
            See details
          </Typography>
        </div>
      </div>
    )
  }
)
